import { getApi } from "../../services/httpService";


export function investors(){
    return getApi().get('aspen/investor');
}


